/**
 * Функция форматирует направление ветра, на основе заданного угла формирует его компоасное направление в строковом формате.
 * @param {number} degrees Угол направления ветра в градусах.
 * @returns {string} Отформатированное направление ветра.
 */
export const formatWindDirection = (degrees: number) => {
  const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
  const index = Math.round(degrees / 45) % 8; //определяет сколько полных секторов по 45 градусов входит в угол degrees
  return `${degrees}\u00B0 (${directions[index]})`;
};
